import { RoadmapCheckpoint } from './RoadmapCheckpoint';
import { RoadmapCTACheckpoint } from './RoadmapCTACheckpoint';
import type { RoadmapMilestone } from '../types';

interface Props {
  milestones: RoadmapMilestone[];
}

export function RoadmapTimeline({ milestones }: Props) {
  return (
    <div className="relative">
      {milestones.map((m, i) => (
        <RoadmapCheckpoint
          key={m.id}
          milestone={m}
          isLast={false}
          index={i}
        />
      ))}
      <RoadmapCTACheckpoint index={milestones.length} />
    </div>
  );
}
